import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import './ErrorSnackbar.scss';

class ErrorSnackbar extends React.Component {
  static propTypes = {
    error: PropTypes.shape({
      severity: PropTypes.string,
      message: PropTypes.string,
    }),
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onExited: PropTypes.func,
  }

  static defaultProps = {
    error: null,
    onExited: null,
  };

  constructor(props) {
    super(props);
    this.handleExited = this.handleExited.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.props.onClose();
  };

  handleExited() {
    if (this.props.onExited) {
      this.props.onExited();
    }
  }

  render() {
    const { error } = this.props;
    const severity = error ? (error.severity || 'error') : 'error';
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        className={classNames('tuc-error-snackbar', severity)}
        open={this.props.open}
        autoHideDuration={30000}
        onClose={this.handleClose}
        onExited={this.handleExited}
        ContentProps={{
          'aria-describedby': 'error-snackbar',
        }}
        message={(
          <div id="error-snackbar" className="tuc-error-snackbar-message">
            <ErrorIcon />
            {error && error.message}
          </div>
        )}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={this.handleClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    );
  }
}

export default ErrorSnackbar;
